import ProductRail from "./home/ProductRail";
import harnessImage from "../assets/images/harness.png";

function ListingsSection({selectedPart,parts}){


const filteredParts = selectedPart
  ? parts.filter(p => p.id === selectedPart.id)
  : parts;


const items = filteredParts.map((p) => ({
  id: p.id,
  title: p.name,
  price: `$${p.price}`,
  image: harnessImage,
  delivery: "Fri, Apr 26 - Mon, Apr 29",
  fastest: "Apr 25"
}));


return(

<div style={styles.section}>



<ProductRail

  title={
    selectedPart?.name
      ? `Listings for ${selectedPart.name}`
      : "All Listings"
  }
  items={items}
/>

</div>

)

}

export default ListingsSection

const styles={

section:{
maxWidth:1400,
margin:"40px auto",
padding:"0 48px"
},

title:{
fontSize:22,
fontWeight:600,
marginBottom:20
},



}